const StyleC = () => {
  return (
    <div className="style-c">
      <style>{`
        .style-c {
          --bg-primary: #ffffff;
          --bg-secondary: #f8fafc;
          --bg-gradient-start: #4f46e5;
          --bg-gradient-end: #06b6d4;
          --text-primary: #0f172a;
          --text-secondary: #475569;
          --text-light: #64748b;
          --accent-primary: #4f46e5;
          --accent-secondary: #06b6d4;
          --accent-warm: #f59e0b;
          --border: #e2e8f0;
          --shadow: rgba(15, 23, 42, 0.1);
          --glow: rgba(79, 70, 229, 0.2);
        }
        
        .style-c.dark {
          --bg-primary: #0f172a;
          --bg-secondary: #1e293b;
          --bg-gradient-start: #6366f1;
          --bg-gradient-end: #0ea5e9;
          --text-primary: #f8fafc;
          --text-secondary: #cbd5e1;
          --text-light: #94a3b8;
          --accent-primary: #6366f1;
          --accent-secondary: #0ea5e9;
          --accent-warm: #fbbf24;
          --border: #334155;
          --shadow: rgba(0, 0, 0, 0.3);
          --glow: rgba(99, 102, 241, 0.3);
        }

        .style-c {
          background: var(--bg-primary);
          color: var(--text-primary);
          font-family: 'Inter', sans-serif;
          line-height: 1.6;
        }
        
        .style-c h1, .style-c h2, .style-c h3 {
          font-family: 'Inter', sans-serif;
          font-weight: 800;
          letter-spacing: -0.025em;
        }
        
        .style-c h1 {
          font-size: 3.75rem;
          line-height: 1;
          margin-bottom: 1.5rem;
          background: linear-gradient(135deg, var(--bg-gradient-start), var(--bg-gradient-end));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .style-c h2 {
          font-size: 2.25rem;
          line-height: 1.2;
          margin-bottom: 1rem;
        }
        
        .style-c h3 {
          font-size: 1.5rem;
          color: var(--accent-primary);
          margin-bottom: 0.75rem;
        }
        
        .style-c .modern-card {
          background: var(--bg-secondary);
          border: 1px solid var(--border);
          border-radius: 16px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }
        
        .style-c .modern-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 20px 40px var(--shadow);
        }
        
        .style-c .modern-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary), var(--accent-warm));
        }
        
        .style-c .gradient-text {
          background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 600;
        }
        
        .style-c .modern-button {
          background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 12px;
          font-weight: 600;
          font-size: 1rem;
          box-shadow: 0 4px 16px var(--glow);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .style-c .modern-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 8px 24px var(--glow);
        }
        
        .style-c .modern-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.5s;
        }
        
        .style-c .modern-button:hover::before {
          left: 100%;
        }
        
        .style-c .feature-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin: 2rem 0;
        }
        
        .style-c .asymmetric-layout {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 2rem;
          align-items: start;
        }
        
        .style-c .tech-accent {
          display: inline-block;
          padding: 0.25rem 0.75rem;
          background: var(--accent-primary);
          color: white;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
          margin: 0.25rem;
        }
        
        .style-c .glow-box {
          background: var(--bg-secondary);
          border: 1px solid var(--border);
          border-radius: 20px;
          padding: 2rem;
          position: relative;
        }
        
        .style-c .glow-box::after {
          content: '';
          position: absolute;
          inset: -1px;
          padding: 1px;
          background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
          border-radius: 20px;
          mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          mask-composite: xor;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .style-c .glow-box:hover::after {
          opacity: 1;
        }
      `}</style>
      
      <div className="max-w-6xl mx-auto px-8 py-12">
        <header className="text-center" style={{marginBottom: '4rem'}}>
          <h1>Modern Institutional</h1>
          <p style={{
            color: 'var(--text-secondary)', 
            fontSize: '1.25rem', 
            maxWidth: '700px', 
            margin: '0 auto',
            fontWeight: '500'
          }}>
            Contemporary design language that bridges the gap between <span className="gradient-text">cutting-edge technology</span> and traditional institutional values.
          </p>
        </header>

        <section className="asymmetric-layout" style={{marginBottom: '4rem'}}>
          <div>
            <div className="modern-card">
              <h2>Bold Visual Identity</h2>
              <p style={{color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '1.1rem'}}>
                This approach uses strong geometric shapes, vibrant gradients, and dynamic typography 
                to signal innovation while maintaining the trustworthiness that cultural institutions require.
              </p>
              
              <div>
                <span className="tech-accent">AI-Powered</span>
                <span className="tech-accent">Cloud-Native</span>
                <span className="tech-accent">Scalable</span>
                <span className="tech-accent">Secure</span>
              </div>
            </div>
          </div>
          
          <div>
            <div className="glow-box">
              <h3>Tech Forward</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Perfect for institutions looking to position themselves as 
                leaders in digital transformation and technological innovation.
              </p>
            </div>
          </div>
        </section>

        <section style={{marginBottom: '4rem'}}>
          <h2 style={{textAlign: 'center', marginBottom: '2rem'}}>Design Elements</h2>
          
          <div className="feature-grid">
            <div className="modern-card">
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, var(--accent-primary), var(--accent-secondary))',
                borderRadius: '16px',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  background: 'white',
                  borderRadius: '4px'
                }}></div>
              </div>
              <h3>Gradient Accents</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Vibrant gradients create visual hierarchy and suggest technological sophistication.
              </p>
            </div>
            
            <div className="modern-card">
              <div style={{
                width: '60px',
                height: '60px',
                background: 'var(--bg-secondary)',
                border: '2px solid var(--accent-primary)',
                borderRadius: '50%',
                marginBottom: '1rem'
              }}></div>
              <h3>Geometric Shapes</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Clean geometry and asymmetric layouts create dynamic, engaging compositions.
              </p>
            </div>
            
            <div className="modern-card">
              <div style={{
                width: '60px',
                height: '4px',
                background: 'linear-gradient(90deg, var(--accent-primary), var(--accent-secondary), var(--accent-warm))',
                borderRadius: '2px',
                marginBottom: '1rem'
              }}></div>
              <h3>Interactive Elements</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Subtle animations and hover effects provide engaging user experiences.
              </p>
            </div>
            
            <div className="modern-card">
              <div style={{
                width: '60px',
                height: '60px',
                background: 'var(--accent-warm)',
                borderRadius: '8px',
                marginBottom: '1rem',
                boxShadow: '0 8px 24px var(--glow)'
              }}></div>
              <h3>Depth & Shadow</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Layered shadows and glows create depth in the digital interface.
              </p>
            </div>
          </div>
        </section>

        <section className="text-center" style={{padding: '3rem 0', background: 'var(--bg-secondary)', borderRadius: '24px'}}>
          <h2 style={{marginBottom: '1rem'}}>Ready for the Future</h2>
          <p style={{
            color: 'var(--text-secondary)', 
            maxWidth: '600px', 
            margin: '0 auto 2rem',
            fontSize: '1.1rem'
          }}>
            This aesthetic appeals to forward-thinking institutions that want to attract tech-savvy users 
            while maintaining academic credibility.
          </p>
          <button className="modern-button">
            <span style={{position: 'relative', zIndex: 1}}>Explore Modern Solutions</span>
          </button>
        </section>
      </div>
    </div>
  );
};

export default StyleC;